var $ = require("jquery");
window.jQuery = $;
require('@fancyapps/fancybox');
require('slick-carousel');

(function(){
"use strict";

window.QG = window.QG || {};

/*==-------------------------------------------------------------------====
    FUNCTIONS 
====-------------------------------------------------------------------==*/

QG.fancybox = function() {
    if ($(".content-image.active a").length > 0) {
        $(".content-image.active a").fancybox();
    }
    if ($(".image-gallery a").length > 0) {
        $(".image-gallery a").fancybox();
    }
    if ($(".fancybox-inline").length > 0) {
        $(".fancybox-inline").fancybox();
    }
};

QG.slickslider = function() {
    $(".image-carousel").slick({
        adaptiveHeight: false
    });
};

QG.leaveFeedback = function() {
    var feedbackPanel = $(".feedback-container");
    var feedbackButton = $(".feedback-button");
    
    feedbackButton.click(function(e) {
        e.preventDefault();

        if (feedbackPanel.hasClass('active')) {
            feedbackPanel.slideUp(350).removeClass('active');
        }
        else {
            feedbackPanel.addClass('active').slideDown(350);
        }
        
    });
};

QG.fatFooter = function() {
    var footerToggle = $(".fat-footer .expand-toggle");

    $(footerToggle).click(function(e) {
        var footerItem = $(this).parent();
        e.preventDefault();
        
        if (footerItem.hasClass('active')) {
            footerItem.parent().find("ul").slideUp(150);
            footerItem.removeClass('active');
        }
        else {
            footerItem.addClass('active');
            footerItem.parent().find("ul").slideDown(150);
        }
    });
};


/*==-------------------------------------------------------------------====
    INITIALISATION 
====-------------------------------------------------------------------==*/
QG.init = QG.init || [];
QG.init.unshift(QG.fancybox, QG.slickslider, QG.leaveFeedback, QG.fatFooter);

$(document).ready(function() {
    QG.init.forEach(function(f) {
        f();
    });
});

}());